var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.117,
    height: 27.492,
    viewBox: "0 0 33.117 27.492",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1.033)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M23.631,23.486V20.658A5.658,5.658,0,0,0,17.973,15H6.658A5.658,5.658,0,0,0,1,20.658v2.829",
    transform: "translate(-1 1.973)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    transform: "translate(6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M24.243,23.433V20.6A5.658,5.658,0,0,0,20,15.13",
    transform: "translate(6.874 2.027)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16,3.13a5.658,5.658,0,0,1,0,10.962",
    transform: "translate(5.216 -2.946)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomers);
export default __webpack_public_path__ + "static/media/customers.1d6f4ac6b18d8861b25f9869f2b729d3.svg";
export { ForwardRef as ReactComponent };